import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyPosition {
  companyTitle: string;
  responsibilities: string[];
  dateStarted: string;
  dateEnded: string;
}

interface CompanyPositionState {
  data: CompanyPosition;
  isInitialized: boolean;
}

const initialState: CompanyPositionState = {
  data: {
    companyTitle: '',
    responsibilities: [],
    dateStarted: '',
    dateEnded: ''
  },
  isInitialized: false
};

const companyPositionSlice = createSlice({
  name: 'companyPosition',
  initialState,
  reducers: {
    initializePosition: (state, action: PayloadAction<Partial<CompanyPosition>>) => {
      if (!state.isInitialized) {
        state.data = { ...state.data, ...action.payload };
        state.isInitialized = true;
      }
    },
    updatePosition: (state, action: PayloadAction<Partial<CompanyPosition>>) => {
      state.data = { ...state.data, ...action.payload };
    },
    savePosition: (state, action: PayloadAction<CompanyPosition>) => {
      state.data = action.payload;
    },
    resetPosition: () => initialState
  }
});

export const { initializePosition, updatePosition, savePosition, resetPosition } = companyPositionSlice.actions;
export default companyPositionSlice.reducer;